/**
 * Layering z-index tokens.
 *
 * @module @smoothie-framework/ui-core/tokens
 */
export const zIndices = Object.freeze({
    hide: -1,
    base: 0,
    docked: 10,
    dropdown: 1000,
    sticky: 1100,
    overlay: 1300,
    modal: 1400,
    popover: 1500,
    tooltip: 1800,
    max: 2147483647,
});
const Z_INDEX_TOKEN_SET = new Set(Object.keys(zIndices));
export function isZIndexToken(value) {
    return Z_INDEX_TOKEN_SET.has(value);
}
export const Z_INDEX_TOKEN_KEYS = Object.freeze(Array.from(Z_INDEX_TOKEN_SET).sort());
//# sourceMappingURL=z-indices.js.map